/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect, useState } from "react";
import { ContentZoneContext } from "cms/components/context";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";

const BannerComponentDisplay = () => {

    const ctx = useContext(ContentZoneContext);
    const { token } = useAuth();
    const component = ctx?.component;

    const richtext = component?.richtext;
    const onDarkBackground = component?.onDarkBackground ?? false;
    const _image = component?.image;
    const settings = component?.settings;
    const options = settings?.options;
    const useCaption = options?.useCaption;
    const format = settings?.format;

    let position = "center center";
    if (format === "image.format.cropped-focus") {
        position = options?.position;
    }

    let width, height = "100%";
    if (options?.method === "WidthPriority") {
        width = options?.dimension ?? "100%";
    }
    if (options?.method === "HeightPriority") {
        height = options?.dimension ?? "100%";
    }

    const [image, setImage] = useState();

    useEffect(() => {
        async function fetchData () {
            if (_image) {
                const data = await SimpliCityAdminSDK.image.findOne(token, _image);
                setImage(data);
            }
        }
        fetchData();
    }, [token, _image]);

    return (
        <>
            <div
                className={`simplicity-banner-display ${onDarkBackground ? "dark-bg" : ""}`}
                title={image?.alt}
                style={{
                    backgroundImage: `url(${image?.url})`,
                    backgroundPosition: `${position}`,
                    width: width,
                    height: height,
                }}
            >
                <RichTextPreview richtext={richtext} />
            </div>
            {useCaption && image?.description &&
                <div className={"simplicity-image-caption"}>
                    {image?.description}
                </div>
            }
        </>
    );
};

BannerComponentDisplay.displayName = "BannerComponentDisplay";
export { BannerComponentDisplay };
